














































import { cloneDeep } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'

import CheckboxInput from "../../../../../../components/Pi/fields/CheckboxInput/CheckboxInput.vue";
import { UseFields } from '../../../../../../components/Pi/index'
import { FieldData } from '../../../../../../components/Pi/types'
import { errorNotificationWrapper } from '../../../../../../logic/helpers/NotificationService'
import PostApi from '../../../../includes/logic/Api/PostApi'
import BusinessRegistrationEmailValidationIcon
  from '../components/BusinessRegistrationEmailValidationIcon.vue'
import { CompanyData, CompanyRegistrationStep, DataAgreeInfo } from '../types'

@Component({
  components: {
    BusinessRegistrationEmailValidationIcon,
    ValidationObserver,
    CheckboxInput
  },

  data: () => ({
    CompanyRegistrationStep,
  })

})
export default class EmailValidation extends Mixins<UseFields>(UseFields) {
  @Prop() readonly value!: CompanyData

  isLoading = false

  get companyData(): CompanyData {
    return cloneDeep(this.value)
  }

  inputConfigSetup(args: FieldData): FieldData {
    args.setter = (value: any): void => {
      this.value[args.key as string] = value
    }

    return args
  }

  @Emit()
  input(): CompanyData {
    return this.companyData
  }

  @Emit()
  next(): { step: CompanyRegistrationStep } {
    return { step: CompanyRegistrationStep.CodeEmail }
  }

  successMessage(title: string, text: string): void {
    this.$notification.success({
      message: title,
      description: text,
      placement: 'bottomRight',
      class: 'successNotification',
    })
  }

  async sendCodeToEmail(): Promise<void> {
    try {
      // await PostApi.sendRequest('tg', 'validateorganizationemail', { email: this.companyData.company.email })
      await PostApi.sendRequest('tg', 'SendOrganizationEmailConfirmCode', { email: this.companyData.email })

      this.successMessage(
        this.$t('company_registration_step_email_validation_send_code_success_title') as string,
        this.$t('company_registration_step_email_validation_send_code_success_text') as string,
      )
      this.next()
    } catch (error: any) {
      errorNotificationWrapper(this.$t('error').toString(), error)
    }
  }

  mounted() {
    const titleInput = document.querySelector('[translation-key="field_company_registration_email_title"]')
    const isElementHelp = document.getElementById('helper-email')
    if (isElementHelp === null && titleInput !== null) {
      const nextElement = titleInput.nextElementSibling
      nextElement?.insertAdjacentHTML('afterend', `<p id="helper-email" class="text-sm text-gray-500 mb-0">${ this.$t("field_company_registration_email_helper") }</p>`)
    }
  }
}
